/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiEntityType } from './InternalApiEntityType';
import {
    InternalApiEntityTypeFromJSON,
    InternalApiEntityTypeFromJSONTyped,
    InternalApiEntityTypeToJSON,
    InternalApiEntityTypeToJSONTyped,
} from './InternalApiEntityType';
import type { InternalApiScreeningFlow } from './InternalApiScreeningFlow';
import {
    InternalApiScreeningFlowFromJSON,
    InternalApiScreeningFlowFromJSONTyped,
    InternalApiScreeningFlowToJSON,
    InternalApiScreeningFlowToJSONTyped,
} from './InternalApiScreeningFlow';

/**
 * 
 * @export
 * @interface InternalApiCreateScreeningFlowDraft
 */
export interface InternalApiCreateScreeningFlowDraft {
    /**
     * 
     * @type {InternalApiEntityType}
     * @memberof InternalApiCreateScreeningFlowDraft
     */
    entityType: InternalApiEntityType;
    /**
     * 
     * @type {InternalApiScreeningFlow}
     * @memberof InternalApiCreateScreeningFlowDraft
     */
    snapshot: InternalApiScreeningFlow;
    /**
     * 
     * @type {string}
     * @memberof InternalApiCreateScreeningFlowDraft
     */
    note?: string;
}



/**
 * Check if a given object implements the InternalApiCreateScreeningFlowDraft interface.
 */
export function instanceOfInternalApiCreateScreeningFlowDraft(value: object): value is InternalApiCreateScreeningFlowDraft {
    if (!('entityType' in value) || value['entityType'] === undefined) return false;
    if (!('snapshot' in value) || value['snapshot'] === undefined) return false;
    return true;
}

export function InternalApiCreateScreeningFlowDraftFromJSON(json: any): InternalApiCreateScreeningFlowDraft {
    return InternalApiCreateScreeningFlowDraftFromJSONTyped(json, false);
}

export function InternalApiCreateScreeningFlowDraftFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiCreateScreeningFlowDraft {
    if (json == null) {
        return json;
    }
    return {
        
        'entityType': InternalApiEntityTypeFromJSON(json['entityType']),
        'snapshot': InternalApiScreeningFlowFromJSON(json['snapshot']),
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function InternalApiCreateScreeningFlowDraftToJSON(json: any): InternalApiCreateScreeningFlowDraft {
    return InternalApiCreateScreeningFlowDraftToJSONTyped(json, false);
}

export function InternalApiCreateScreeningFlowDraftToJSONTyped(value?: InternalApiCreateScreeningFlowDraft | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entityType': InternalApiEntityTypeToJSON(value['entityType']),
        'snapshot': InternalApiScreeningFlowToJSON(value['snapshot']),
        'note': value['note'],
    };
}

